var map = {
	"./jca/logo-24.svg": "./src/themes/assets/jca/logo-24.svg",
	"./tecnoma/logo-24.svg": "./src/themes/assets/tecnoma/logo-24.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/themes/assets sync recursive ^\\.\\/.*\\/logo\\-24\\.svg$";